import gql from 'graphql-tag'
import {ElementPartsFragment, ProjectPartsFragment} from '../mutations'

export const GET_ELEMENTS = gql`
  query GetElements($parent_id: Int!, $page: Int, $size: Int, $name: String) {
    elements(parent_id: $parent_id, page: $page, size: $size, name: $name) {
      list {
        ...ElementParts
      }
      metadata {
        current_page
        total_pages
      }
    }
  }
${ElementPartsFragment}
`

export const GET_ELEMENT = gql`
  query GetElement($id: ID!) {
    element(id: $id) {
      ...ProjectParts
    }
  }
${ProjectPartsFragment}
`



// WEBPACK FOOTER //
// ./src/components/Projects/tabs/graphql.js